export default {
  美元: 'USD',
  人民币: 'RMB',
  有效期: 'Expiration date',
  暂无优惠: 'No coupon',
  暂无优惠券: 'No coupon',
  领取成功: 'Claimed Successfully!',
  '正在领取中,请稍等': 'Claiming, please wait',
  产品优惠: 'Product Discount',
  应付货品金额标题: 'Amount Payable (Shipping Cost Not Included)',
  优惠券: 'coupon',
  券: 'coupon',
  条件金额不能少于满减金额: 'Minimum spending required cannot be lower than the amount reduced.!',
  优惠券最多领取数: 'Maximum Number of Coupons Claimable',
  天: 'Day(s)',
  领取后X天有效: 'Expires in X Days',
  固定时间: 'Fixed Date',
  优惠券有效期模式: 'Fixed Period Mode',
  打折设置: 'Discount Setting',
  减: 'off',
  满减设置: 'Conditions Setting',
  云优惠说明41: 'Within 500 characters!',
  云优惠说明40: 'Description cannot be empty!',
  云优惠说明39:
    'You can detail the conditions for using the coupons. For example, the coupons is only applicable to certain products or services;',
  云优惠说明38: 'Maximum number claimable cannot be higher than the number issued！',
  云优惠说明37: 'Maximum number claimable: Positive integers only！',
  云优惠说明36: 'Maximum number claimable: Within 5 characters！',
  云优惠说明35: 'Maximum number claimable cannot be empty!',
  云优惠说明34: 'refers to the maximum number of coupons a client can claim. The minimum number is one',
  云优惠说明33: 'Number of coupons issued: Positive integers only！',
  云优惠说明32: 'Number of coupons issued: Within 5 characters！',
  云优惠说明31: 'Number of coupons issued cannot be empty!',
  云优惠说明50: 'means the total number of coupons issued. The minimum number is one, and the maximum 99999',
  云优惠说明30: 'Term of validity: Positive integers only！',
  云优惠说明29: 'Term of validity: Within 5 characters！',
  云优惠说明28: 'Term of validity cannot be empty!',
  云优惠说明27: 'Period of validity cannot be empty!',
  云优惠说明26: 'Please select the fixed period mode!',
  云优惠说明25: 'The range of discount is between 1-99%！',
  云优惠说明24: 'Discount conditions cannot be empty!',
  云优惠说明23: 'Digits only with two decimal places！',
  云优惠说明22: 'Minimum spending required: within 9 characters！',
  云优惠说明21: 'Minimum spending required cannot be empty!',
  云优惠说明20: 'If there is no minimum spending required, please enter zero,The range of discount is between 1-99%',
  云优惠说明19: 'Minimum spending required cannot be empt!',
  云优惠说明18: 'Digits only with two decimal places！',
  云优惠说明17: 'Minimum spending required: within 10 characters！',
  云优惠说明16: 'Minimum spending required cannot be empty!',
  云优惠说明15: 'Digits only with two decimal places！',
  云优惠说明14: 'Minimum spending required: within 10 characters！',
  云优惠说明13: 'Minimum spending required cannot be empty!',
  云优惠说明12: 'If there is no minimum spending required, please enter zero',
  云优惠说明11: 'Minimum spending required cannot be empty!',
  云优惠说明10: 'Please select type of currency!',
  云优惠说明9:
    'A coupon’s type of currency, such as RMB or USD, is only applicable to products listed in the same type of currency. For example, if a products is listed in RMB, then only coupons in RMB are applicable to this product；',
  云优惠说明8: 'Coupon name: within 15 characters！',
  云优惠说明7: 'Coupon name cannot be empty!',
  云优惠说明6: 'Not displayed to other users. For management purpose only. Within 15 characters',
  云优惠说明5:
    'You can add coupons for any products. Corresponding coupons will be automatically recommended to the buyer when an order meets the discount conditions. Coupons are not applicable to products with negotiable prices',
  提前结束成功: 'Ended in advance',
  云优惠说明4:
    'Once ended, this coupon will no longer be claimable (coupons claimed earlier are stilled valid). Are you sure you want to end this promotion?',
  优惠券使用状态: 'Status',
  注册账号: 'Account (Phone/E-mail/sub-account)',
  已失效: 'Ended',
  失效: 'End Promotion',
  确定要失效此优惠券吗: 'Are you sure you want to end this promotion?',
  使用状态: 'Status',
  人: 'people',
  已领取优惠券: 'have claimed this coupon',
  查看: 'View',
  优惠券说明: 'Description',
  优惠券发行数量: 'Coupon issued in total',
  使用终端: 'Device',
  提前结束: 'End in Advance',
  显示顺序不可重复: 'Display order cannot be repeated!',
  优惠券ID: 'Coupon ID',
  优惠券名称: 'Coupon Name',
  面额折扣: 'Amount Reduced/Discount',
  已领取人数: 'Number of Clients Who Have Coupon(s)',
  创建折扣优惠券: 'Add Discount Coupon',
  创建满减优惠券: 'Add Conditional Coupon',
  云优惠说明3:
    'You can view details of the coupons claimed by clients, or deactivate a coupon (please use this feature based on thorough consideration);',
  云优惠说明2: 'New coupons are applicable to any of your products and any order by default；',
  云优惠说明1:
    'You can set the display order of your coupon. The bigger the number, the more prominently the coupon will be displayed；',
  折扣券: 'Discount',
  满减券: 'Conditional',
  平台券: 'Platform Coupon',
  展览券: 'Exhibition Coupon',
  产品券: 'Product Coupon',
  可用: 'Can use',
  满: 'full',
  优惠券币种: 'Type of Currency',
  有效时间: 'Promotional Period',
  复制成功: 'Copied Successfully',
  券码: 'Coupon Code',
  领取时间: 'Date of Receipt',
  折: 'off',
  已领取: 'CLAIMED',
  立即领取: 'Receive',
  立即使用: 'USE NOW',
  我的优惠券说明2:
    'Self-defined coupon is a type of coupon that doesn’t have a predetermined condition, and terms are open for discussion between the buyer and the supplier；',
  我的优惠券说明1:
    'If a buyer has claimed a self-defined coupon, the buyer can ask the supplier for the coupon coed to place order after the two parties reach an agreemen；',
  适用的产品: 'Applicable Exhibits',
  适用的展览: 'Applicable Exhibitions',
  未使用: 'Unused',
  已使用: 'Used',
  已过期: 'Expired',
}
